<template lang="pug">
  div
    div(class="m-block-premium-features-stepper__image")
      v-img(
        :src="require('~/assets/images/dubidoc-premium-bg.png')"
        max-width="100%"
        height="200"
      )
    div(class="m-block-premium-features-stepper__content")
      h2(class="title-32px fw-700 mb-2") {{ $t('You have 14 days of Premium access') }}
      div(class="text-14px mb-6 fw-300") {{ introSubtitle }}
      div(class="m-block-premium-features-stepper__features")
        div(
          v-for="feature in features"
          :key="feature"
          class="m-block-premium-features-stepper__features-item"
        )
          e-svg-icon check-black
          span(class="text-12px dark fw-300") {{ feature }}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OnboardingFeaturesIntroBlock',
  props: {
    features: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters('organizations', {
      organizations: 'items'
    }),
    introSubtitle() {
      return !this.organizations.length
        ? this.$t(
            'To activate it - add an organization. After that you will immediately get access to all Premium features:'
          )
        : this.$t(
            'Folders, routes, comments, collaboration - everything to work with documents faster and more conveniently. Now available in Premium'
          )
    }
  }
}
</script>

<style scoped lang="scss"></style>
